import React, { Component } from "react";
import { Field, reduxForm, FormSection, formValueSelector } from "redux-form";
import axios from "axios";

import { TabContent, TabPane, Nav, NavItem, NavLink, Card, CardBody, Button, CardTitle, CardText, Row, Col } from 'reactstrap';
import Address from "../common/address";
import Borrower from "./borrower";
import Instruction from "./AddInstruction";
import classnames from 'classnames';
import { connect } from "react-redux";
import PageSpinner from "../PageSpinner";
import TileButton from '../common/TileButton';
import appConfig from '../../config/config';
import {MTSLoadData} from '../../API/mtsapi'
class OrderEditForm extends Component {

    constructor(...args) {
        super(...args);
        this.state = {
            showBanner: false, message: '', IsDataLoaded: false
        };
    }
    componentDidMount() {
        MTSLoadData(appConfig.apiGateway.searchOrderUrl,
                    { OrderId: this.props.OrderId, Action: "OrderProduct" },
                    this.props.dispatch);

            this.setState({ ...this.state, IsDataLoaded: true });
    }
    render() {
        if (!this.state.IsDataLoaded)
            return (
                <>
                    <PageSpinner />
                </>
            );

        return (
            <>
            <div className="form-row mb-3">
                {/* <div class="col-lg-6 col-xl-3">
                    <TileButton Menu="New Order" TileType="New"/>
                </div> */}

                <Card className="col-12">
                    <CardBody>
                        <CardTitle><strong>Property Address</strong></CardTitle>
                            <Address  />
                    </CardBody>
                </Card>
            </div>
            <div className="form-row">
                <Card className="col-12 mb-3">
                    <CardBody>
                        <CardTitle><strong>Borrower</strong></CardTitle>
                        <Borrower prefix="Borrower" />
                    </CardBody>
                </Card>

            </div>
            <div className="form-row">
                <Card className="col-12 mb-3">
                    <CardBody>
                        <CardTitle><strong>Agent/Contact</strong></CardTitle>
                        <Borrower prefix="Agent" />
                    </CardBody>
                </Card>
            </div>
            <div className="form-row">
                <Card className="col-12 mb-3">
                    <CardBody>
                        <CardTitle><strong>Additional Instructions</strong></CardTitle>
                        <Instruction />
                    </CardBody>
                </Card>
            </div>
            <div className="form-row">
                <Card className="col-12 mb-3">
                    <CardBody>
                        <div className="text-right">
                            <Button color="primary" type="submit" className="mr-3">Save</Button>
                            <Button type="button">Cancel</Button>
                        </div>
                    </CardBody>
                </Card>
                </div>
                </>
            );
    }
}


const validate = (formValues) => {
    const errors = {};

    return errors;
}
var orderEditform = reduxForm({
    form: 'orderEditForm',
    validate,
    enableReinitialize: true
})(OrderEditForm);

orderEditform = connect(
    state => ({
        initialValues: state.loadOrder.editdata
    })
)(orderEditform);

export default orderEditform;
